/************************************************************************
** IBM Confidential
**
** IBM Business Analytics: Rapidly Adaptive Visualization Engine
**
** (C) Copyright IBM Corp. 2012,2017
**
** The source code for this program is not published or otherwise divested of its trade secrets, 
** irrespective of what has been deposited with the U.S. Copyright Office.
************************************************************************/

// @import ../../../init/declare
/**
 * This is the base class for a module object that requires the clone functionality.
 */
export default class BaseMoserObject {
	
	/**
	 * The base clone() method to make a copy of the properties from the original object.
	 * @param {MoserObject} original - the object to be copied from
	 * @return the cloned MoserObject object
	 */
	static _clone(original) {
	    var clone = Object.create(Object.getPrototypeOf(original));
	    var featureList = original.getFeatureList(null);

	    for (var j = 0; j < featureList.length; j++) {
			var featureName = featureList[j].getFeatureName();			
			clone[featureName] = original[featureName];
		}

	    return clone;
	}
	
	/**
	 * Makes a shallow copy of a list.
	 */
	static cloneList(original) {
		return original != null ? original.slice() : null;
	}
	
	/**
	 * This is called by its subclasses to copy the basic properties of itself
	 * @return a copy of itself
	 */
	_clone() {
		return BaseMoserObject._clone(this);
	}
	
	/**
	 * Get the class object
	 */
	getClass() {
		return this.constructor;
	}
}


// WEBPACK FOOTER //
// ./src/generated/BaseMoserObject.js